import React from 'react';
import { Constants, DividerBorder, Page_Padding } from '../../shared/constants';
import {
    Box,
    Grid2,
    Typography,
} from '@mui/material';
import CustomDivider from '../../shared/utils/CustomDivider';
import ReviewRatingCom from '../../shared/components/ReviewRatingCom';
import UiUxDevelopement from './UiUxDevelopement';
import { ReviewRating } from './ReviewRating';
import CourseCard from '../../shared/components/CourseCard';
import HorizontalScroll from '../../shared/components/HorizontalScroll';
import useResponsive from '../../shared/utils/Responsive';
import { useCourseDetail } from '../../assets/api/useGetApi';
import { SkeletonCom } from '../../shared/utils/SkeletonCom';
import { useParams } from 'react-router-dom';

const CourseDetail = () => {
    const { id } = useParams();
    const isSmallScreen = useResponsive("md")
    const { data: coursesDetail, isLoading } = useCourseDetail(id);

    const itemData = [
        { img: `https://stage.myskool.club/collab/assets/images/event/cover/${coursesDetail?.data?.cover_image}`, title: 'Image 1' },
        { img: Constants.customImages.CourseDetailImg1, title: 'Image 2' },
        { img: Constants.customImages.CourseDetailImg2, title: 'Image 3' }
    ];

    const renderCourseCards = () =>
        !isLoading
            ? coursesDetail?.related_courses?.map((item, index) => (
                <Grid2
                    children
                    key={index}
                    size={{ xs: 12, sm: 5.7, lg: 3.7 }}
                    sx={{ flex: "0 0 auto", display: "flex", alignItems: "stretch" }}
                >
                    <CourseCard item={item} />
                </Grid2>
            ))
            : [...Array(6)].map((_, index) => (
                <Grid2 children key={index} size={{ xs: 12, sm: 5.7, lg: 3.7 }} sx={{ flex: "0 0 auto" }}>
                    <SkeletonCom />
                </Grid2>
            ));

    return (
        <Box className="body course_detail" px={Page_Padding}>
            <Grid2 container spacing={2}>
                <Grid2 size={{ xs: 12, sm: 8 }}>
                    <img
                        src={itemData[0].img}
                        alt={itemData[0].title}
                        width="100%"
                        style={{ objectFit: "cover", height: isSmallScreen?"260px":"400px" }} // Adjust height as needed
                    />
                </Grid2>
                <Grid2 container size={{ xs: 12, sm: 4 }} spacing={2}>
                    {itemData.slice(1).map((item, index) => (
                        <Grid2 key={index} size={{ xs: 6, sm: 12 }}>
                            <img
                                src={item.img}
                                alt={item.title}
                                width="100%"
                                style={{ objectFit: "cover", maxHeight: "190px" }} // Adjust height as needed
                            />
                        </Grid2>
                    ))}
                </Grid2>
            </Grid2>
            <CustomDivider orientation='horizontal' />
            <UiUxDevelopement />
            <CustomDivider orientation='horizontal' />

            {coursesDetail?.related_courses?.length <= 3 ? (
                <>
                    <Typography variant="h5" my={3}>
                        Related Courses
                    </Typography>
                    <Grid2 container spacing={"30px"}>{renderCourseCards()}</Grid2>
                </>

            ) : (
                <>
                    <Typography variant="h5" mb={"-35px"}> Related Courses</Typography>
                    <HorizontalScroll size={3}>{renderCourseCards()}</HorizontalScroll>
                </>

            )}
            <CustomDivider orientation='horizontal' />
            <Box>
                <CustomDivider sx={{ borderTop: DividerBorder }} size={"50px"} />
                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <img src={Constants.customImages.GrainLeft} height={isSmallScreen ? "150px" : "200px"} />
                    <Box>

                        <Typography
                            variant='body1'
                            textAlign={"center"}
                            sx={{ fontSize: { xs: "40px", sm: "70px" }, lineHeight: "120px" }}
                        >
                            4.24
                        </Typography>
                        <Typography variant='body1' textAlign={"center"}>This course is students favourite based on their review and ratings</Typography>
                    </Box>

                    <img src={Constants.customImages.GrainRight} height={isSmallScreen ? "150px" : "200px"} />
                </Box>

                <CustomDivider sx={{ borderBottom: DividerBorder }} size={"50px"} />
            </Box>
            <CustomDivider />
            <Typography variant="h5" >Review & Rating</Typography>
            {Array.from({ length: 3 }).map((_, index) => (
                <ReviewRatingCom key={index} />
            ))}
            <CustomDivider orientation='horizontal' />
            <ReviewRating />



        </Box>



    );
};

export default CourseDetail;
